import React from 'react';
import classNames from 'classnames';

import css from './IconGooglePay.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "IconGooglePay" icon
 */
const IconGooglePay = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="35"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#7DC0F4" />
      <path
        d="M27.4971 14.3193H27.5146L28.9736 10.6562H30L26.8457 17.9999H25.873L27.0449 15.4316L24.9766 10.6562H26.002L27.4971 14.3193ZM22.5615 10.4892C23.2588 10.4893 23.8095 10.6801 24.2139 11.0546C24.6182 11.4292 24.8183 11.9523 24.8184 12.6123V15.7587H23.915V15.0507H23.874C23.4814 15.6334 22.9659 15.9246 22.3154 15.9248C21.7645 15.9248 21.295 15.7587 20.9258 15.4257C20.5624 15.1165 20.3574 14.6584 20.3691 14.1767C20.3691 13.6475 20.5683 13.2311 20.9609 12.916C21.3537 12.6008 21.8816 12.4462 22.5381 12.4462C23.1006 12.4463 23.5576 12.5537 23.9209 12.7558V12.5351C23.9208 12.2081 23.7803 11.8985 23.5342 11.6845C23.2822 11.4587 22.9599 11.334 22.626 11.3339C22.0985 11.3339 21.6817 11.5598 21.377 12.0117L20.5449 11.4824C20.9904 10.8225 21.6648 10.4892 22.5615 10.4892ZM18.0889 8.30073C18.6926 8.28885 19.2792 8.52101 19.707 8.94916C20.5626 9.75788 20.6153 11.1199 19.8125 11.9941L19.707 12.1015C19.2674 12.5237 18.7278 12.7372 18.0889 12.7373H16.5293V15.7587H15.5859V8.30073H18.0889ZM22.6846 13.2197C22.3036 13.2197 21.9815 13.3147 21.7236 13.499C21.4716 13.6833 21.3419 13.9149 21.3418 14.1943C21.3418 14.444 21.4599 14.6766 21.6533 14.8193C21.8643 14.9855 22.1221 15.0742 22.3857 15.0683C22.7842 15.0683 23.165 14.9082 23.4463 14.623C23.757 14.3257 23.916 13.9746 23.916 13.5703C23.6229 13.3324 23.2122 13.2137 22.6846 13.2197ZM16.5293 11.8212H18.1123C18.464 11.8331 18.8046 11.6911 19.0449 11.4355C19.5373 10.9182 19.5255 10.0854 19.0156 9.58588C18.7753 9.34801 18.4523 9.21674 18.1123 9.21674H16.5293V11.8212Z"
        fill="#3C4043"
      />
      <path
        d="M13.273 12.0831C13.273 11.7917 13.2495 11.5003 13.2027 11.2148H9.22266V12.8621H11.5028C11.409 13.3914 11.1042 13.8671 10.6587 14.1644V15.2349H12.0186C12.8158 14.4915 13.273 13.3914 13.273 12.0831Z"
        fill="#4285F4"
      />
      <path
        d="M9.22211 16.2696C10.3592 16.2696 11.3205 15.889 12.0181 15.2349L10.6582 14.1645C10.2772 14.4261 9.79068 14.5748 9.22211 14.5748C8.12013 14.5748 7.18815 13.8195 6.85404 12.8086H5.45312V13.9147C6.16824 15.3598 7.62776 16.2696 9.22211 16.2696Z"
        fill="#34A853"
      />
      <path
        d="M6.85401 12.8088C6.67814 12.2796 6.67814 11.7027 6.85401 11.1675V10.0674H5.45288C4.84904 11.2746 4.84904 12.7018 5.45288 13.909L6.85401 12.8088Z"
        fill="#FBBC04"
      />
      <path
        d="M9.22211 9.40114C9.82585 9.38925 10.4061 9.62117 10.8399 10.0434L12.0474 8.81836C11.2795 8.09285 10.2713 7.69442 9.22211 7.70631C7.62776 7.70631 6.16824 8.62211 5.45312 10.0672L6.85404 11.1733C7.18815 10.1564 8.12013 9.40114 9.22211 9.40114Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default IconGooglePay;
